export default "__VITE_ASSET__CXvv$cAS__"